import React, { Component } from 'react';
import Dropzone from 'react-dropzone';
import TextField from '@material-ui/core/TextField';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Button from '@material-ui/core/Button';
import Image from '@material-ui/icons/Image';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import KobooRoundInput from '../../constants/KobooRoundInput.css';
import KobooButton from '../Layout/KobooButton';
import styles from '../../constants/stylesDefault';
import * as routes from '../../constants/routes';
import { postRenter, postRenterPicture } from '../../store/renters/actions';
import Spinner from '../Layout/Spinner';
import { EditRenterForm } from './EditRenterForm';
import { dispatchInfo, handleError } from '../../store/infos/actions';
import { ROLE_ADMIN } from '../../constants/roles';

const byPropKey = (propertyName, value) => () => ({
  [propertyName]: value,
});

const INITIAL_STATE = {
  name: '',
  rib: '',
  logo: '',
  pictureToUpload: null,
  sending: false,
  maxTimeBeforeEmbargo: 0
};

export class AddRenterForm extends Component {
  static propTypes = {
    authUser: PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.state = { ...INITIAL_STATE };
  }

  static supportedDropFiles =  [
    'image/bmp',
    'image/x-ms-bmp',
    'image/png',
    'image/x-icon',
    'image/vnd.microsoft.icon',
    'image/jpeg',
    'image/gif',
    'image/svg+xml',
  ].toString();

  onSubmit = (event) => {
    const {
      name,
      rib,
      mail,
      maxTimeBeforeEmbargo
    } = this.state;
    this.props.postRenter(this.props.authUser.ma, { name, rib, mail, maxTimeBeforeEmbargo }).then(renterId => {
      if (renterId) {
        if (this.state.pictureToUpload) { // picture To Upload after track sent
          this.props.postRenterPicture(
            this.props.authUser.ma,
            renterId,
            this.state.pictureToUpload,
            (progressEvent) => {
              const percentCompleted = Math.round((progressEvent.loaded * 100)
                / progressEvent.total);
              this.props.dispatchInfo(this.state.pictureToUpload.name + ' -> '
                + percentCompleted
                + '% (' + progressEvent.loaded + ' / ' + progressEvent.total + ')');
            }).then(value => {
              if (value) {
                this.props.history.push(routes.RENTERS);
              }
          })
        } else {
          this.props.history.push(routes.RENTERS);
        }
      }
    });
    event.preventDefault();
  };

  handleAddMedia = () => {
    this.dropzoneRef.open();
  };

  handleMediaDrop = (accepted, rejected) => {
    if (rejected.length) {
      this.props.handleError({ message: "Le format du fichier n'est pas compatible." });
    } else {
      this.setState({
        logo: accepted[0].preview,
        pictureToUpload: accepted[0]
      });
    }
  };

    render() {
      const {
        name,
        rib,
        mail,
        logo,
        maxTimeBeforeEmbargo
      } = this.state;

      const isInvalid = name === '' ;

      return (
        <form onSubmit={this.onSubmit} style={styles.center}>
          <Card>
            <CardContent>
              <Typography gutterBottom variant="h5" component="h2">
                Logo du loueur
              </Typography>
            </CardContent>
            <Dropzone
              style={styles.media}
              ref={(node) => {
                this.dropzoneRef = node
              }}
              accept={EditRenterForm.supportedDropFiles}
              onDrop={this.handleMediaDrop}
            >
              {logo ?
                <CardMedia
                  component="img"
                  image={logo}
                  title='Logo du loueur'
                />
                :
                <div>
                  <Typography variant="subtitle1">Glissez votre image dans cette zone.</Typography>
                  <br/>
                  <Image/>
                </div>
              }
            </Dropzone>
            <CardActions>
              <Button
                size="small"
                color="primary"
                onClick={ this.handleAddMedia }
              >
                Ajouter une image
              </Button>
            </CardActions>
          </Card>
          <TextField
            style={KobooRoundInput.round}
            placeholder="Nom"
            id="renter-name"
            type="text"
            onChange={event => this.setState(byPropKey('name', event.target.value))}
            margin="normal"
            value={name}
            InputProps={{
              disableUnderline: true,
            }}
          />
          <TextField
            style={KobooRoundInput.round}
            placeholder="Rib"
            id="renter-rib"
            type="text"
            onChange={event => this.setState(byPropKey('rib', event.target.value))}
            margin="normal"
            value={rib}
            InputProps={{
              disableUnderline: true,
            }}
          />
          {this.state.role === ROLE_ADMIN &&
            <TextField
              style={KobooRoundInput.round}
              placeholder="Mail"
              id="renter-mail"
              type="text"
              onChange={event => this.setState(byPropKey('mail', event.target.value))}
              margin="normal"
              value={mail}
              InputProps={{
                disableUnderline: true,
              }}
            />
          }
            <Typography>Définir le temps avant que l'embargo se déclenche (en minutes)</Typography>
            <TextField
              style={KobooRoundInput.round}
              type="number"
              inputProps={{
                min : 0,
                step : 1
              }}
              id="renter-maxTimeBeforeEmbargo"
              value={maxTimeBeforeEmbargo}
              onChange={
                event => this.setState(byPropKey('maxTimeBeforeEmbargo', Number(event.target.value)))
              }
              helperText={maxTimeBeforeEmbargo < 0 ? 'La valeur doit être égale ou supérieur à 0' : ''}
              error={maxTimeBeforeEmbargo < 0}
              FormHelperTextProps={{
                style: KobooRoundInput.helperText
              }}
              InputProps={{
                disableUnderline: true,
              }}
            >
            </TextField>
          <KobooButton disabled={this.props.sending || isInvalid} type="submit">
            {this.props.sending ?
              <Spinner style={{ parent: { margin: '4px auto 0' }, child: {} }}/> : 'Créer'}
          </KobooButton>
        </form>
      );
    }
}

function mapStateToProps(state) {
  return {
    authUser: state.users.authUser,
    pending: state.renters.pending,
    sending: state.renters.sending
  };
}

export default connect(mapStateToProps,
  { postRenter, postRenterPicture, handleError, dispatchInfo })(AddRenterForm);



// WEBPACK FOOTER //
// ./src/components/Renter/AddRenterForm.jsx